import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";
import { getSubdivisionOptionsForCodes } from "@/lib/utils/countries";

type Props = {
  id?: string;
  selected: Array<string>;
  onSelect: (values: Array<string>) => void;
  className?: string;
};

export type SourceStateData = ResultOf<typeof sourceStateCodesQuery>;

export function SourceStatePicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(sourceStateCodesQuery, {
    variables: { businessUnit: activeBusinessUnitId },
  });

  const options = getSubdivisionOptionsForCodes(removeNothings(data?.supplyChainLotSourceStateCodes || []));

  return (
    <Combobox<string>
      id={id}
      name="source-states"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const sourceStateCodesQuery = graphql(`
  query SupplyChainLotSourceStateCodes($businessUnit: ID) {
    supplyChainLotSourceStateCodes(businessUnit: $businessUnit)
  }
`);
